/**
 * Chi è già dei nostri, e da quando.
 *
 * Un dipendente si registra in anagrafica prima che cominci a lavorare: i
 * documenti si preparano, la visita medica si prenota, il tesserino si stampa.
 * Fino al giorno dell'assunzione però non si può mandare in cantiere né
 * mettere in reperibilità, e comparire fra i disponibili sarebbe solo un modo
 * per assegnarlo per sbaglio.
 *
 * La regola sta qui, in un posto solo: dipende dal giorno per cui si sta
 * assegnando, non da oggi. Se comincia lunedì, per la pianificazione di lunedì
 * c'è.
 */
export const oggiIso = () => new Date().toISOString().slice(0, 10);

/** Vero se questa persona, in quel giorno, non era ancora stata assunta. */
export function nonAncoraAssunto(dipendente, giorno = oggiIso()) {
  const assunzione = String(dipendente?.hire_date || "").slice(0, 10);
  if (!assunzione) return false;          // chi non ha la data c'è sempre stato
  return assunzione > String(giorno || "").slice(0, 10);
}

/**
 * Chi lavora in ufficio e non si manda in cantiere.
 *
 * Si riconosce dall'account con cui entra nell'app - tecnico o amministrativo
 * - non dalla mansione: «Tecnico Impiantista» è un mestiere da cantiere, e
 * cercare la parola nel mestiere toglierebbe dalle squadre proprio chi ci
 * lavora. Il preposto in cantiere ci va, e resta assegnabile.
 */
export function inUfficio(dipendente) {
  return !!dipendente?.in_ufficio;
}

/**
 * L'elenco di chi si può davvero mandare in cantiere quel giorno: fuori chi
 * deve ancora entrare in azienda e chi sta in ufficio.
 */
export function soloAssunti(dipendenti, giorno = oggiIso()) {
  return (dipendenti || []).filter((d) => !nonAncoraAssunto(d, giorno) && !inUfficio(d));
}

/** "dal 01/10/2026", da scrivere accanto al nome di chi deve ancora entrare. */
export function daQuando(dipendente) {
  const assunzione = String(dipendente?.hire_date || "").slice(0, 10);
  if (!assunzione) return "";
  return `dal ${assunzione.split("-").reverse().join("/")}`;
}

/**
 * Chi non si puo' mandare in cantiere perche' la pratica di assunzione non e'
 * conclusa.
 *
 * Il server lo rifiuta comunque: questo serve perche' chi compone la squadra
 * lo veda prima, e sappia cosa manca. Vale solo per chi e' stato assunto da
 * quando la pratica esiste - l'elenco del personale attacca `pratica` solo a
 * loro - quindi su tutti gli altri risponde sempre falso.
 */
export function bloccatoDaPratica(dipendente) {
  const p = dipendente?.pratica;
  return !!p && p.assegnabile === false;
}

/** «manca: visita medica, unilav», da scrivere accanto al nome. */
export function cosaMancaPratica(dipendente) {
  const p = dipendente?.pratica;
  if (!p || !p.mancano?.length) return "";
  return p.mancano.length <= 2
    ? p.mancano.join(", ").toLowerCase()
    : `${p.mancano.length} vincoli`;
}
